module.exports = __webpack_public_path__ + "static/img/7839_phase_function_Paper_PointsHejduk_Prediction.a2612f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7839_phase_function_Paper_PointsHejduk_Prediction.png
// module id = l3L8
// module chunks = 0